<template>
  <div class="project dinline-block vtop fs14 tleft trans">
    <div class="igs ofhidden br5">
      <img v-if="item.pic==''" class="trans3" src="../../assets/images/pic.jpg" width="370" height="160" />
      <img v-else class="trans3" :src="item.pic" width="370" height="160" />
    </div>
    <div class="txt pl10 pr10" style="padding: 0">
      <div class="nm fs22 fbold ofhidden mt15 mb10 lh10">{{item.name}}</div>
      <div class="fs13 tc9 lh16">{{item.description}}</div>
      <div class="tc13 mt10">报名时间：{{item.deadline|formatDate}}</div>
      <div class="btns mt20">
        <a href="javascript:;" class="zbtn zbtn-bblue br30 mr5" @click="goRoute(item.id,item.type_id,item.name)">马上报名</a>
        <a href="javascript:;" @click="goRoute(item.id,item.type_id,item.name)" class="zbtn zbtn-bblue br30">详细情况</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "train-item",
  props: [
    'item',
    'index',
  ],
  filters: {
    formatDate: function (value) {
      let date = new Date(value * 1000);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m;
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s;
      return y + '-' + MM + '-' + d;
    }
  },
  methods:{
    goRoute(id,type_id,name){
      if(type_id == 1){
        this.$router.push({path:'/train/project/detail',query:{id:id}})
      }
      if(type_id == 3){
        this.$router.push({path:'/train/project/sign',query:{id:id,name:name}})
      }

    },
  }
}
</script>

<style scoped>
  .project:hover{box-shadow: 0 0 15px #666;}
  .project:hover .nm{color: #147ad8;}
  .project{margin: 0 35px 25px;padding: 10px 10px 20px;width: 380px;border-radius: 10px;}
  .project:nth-child(3n){margin-right: 0;}
  .project:nth-child(3n + 1){margin-left: 0;}
  .project .nm{height: 24px;}
  .project .zbtn{padding: 5px 15px;}
</style>



// WEBPACK FOOTER //
// src/components/index/train-item.vue